var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubscribedUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.602,
    height: 20.24,
    viewBox: "0 0 27.602 20.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people",
    transform: "translate(-1.5 -7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14240",
    "data-name": "Path 14240",
    d: "M28.519,17.62a4.415,4.415,0,0,1-3.22-1.486A5.744,5.744,0,0,1,23.8,12.627,4.8,4.8,0,0,1,25.019,8.96a4.9,4.9,0,0,1,6.99.007,4.791,4.791,0,0,1,1.222,3.659,5.76,5.76,0,0,1-1.495,3.507A4.4,4.4,0,0,1,28.519,17.62ZM32.314,12.56Z",
    transform: "translate(-8.619 0)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14241",
    "data-name": "Path 14241",
    d: "M33.28,35.28H18.12a1.593,1.593,0,0,1-1.265-.614,1.738,1.738,0,0,1-.3-1.483,7.578,7.578,0,0,1,3.468-4.662A10.907,10.907,0,0,1,25.7,27a10.807,10.807,0,0,1,5.676,1.5,7.536,7.536,0,0,1,3.472,4.689,1.741,1.741,0,0,1-.306,1.482A1.592,1.592,0,0,1,33.28,35.28Z",
    transform: "translate(-5.799 -7.54)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14242",
    "data-name": "Path 14242",
    d: "M11.273,19.01a4.323,4.323,0,0,1-3.967-4.193A4.054,4.054,0,0,1,8.34,11.733,3.948,3.948,0,0,1,11.273,10.5,3.934,3.934,0,0,1,14.2,11.74a4.022,4.022,0,0,1,1.035,3.077A4.322,4.322,0,0,1,11.273,19.01Z",
    transform: "translate(-2.24 -1.16)",
    fill: "#6a707e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14243",
    "data-name": "Path 14243",
    d: "M12.808,26.856a8.727,8.727,0,0,0-3.775-.742A8.894,8.894,0,0,0,4.4,27.357a6.238,6.238,0,0,0-2.852,3.836,1.575,1.575,0,0,0,.275,1.343,1.456,1.456,0,0,0,1.155.561H9.361a.46.46,0,0,0,.453-.378c.006-.036.014-.073.024-.108a8.329,8.329,0,0,1,3.318-4.82.46.46,0,0,0-.036-.77c-.09-.053-.194-.109-.312-.166Z",
    transform: "translate(0 -7.198)",
    fill: "#6a707e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribedUsers);
export default __webpack_public_path__ + "static/media/subscribed-users.0668926c644382cc16988feded7ae4de.svg";
export { ForwardRef as ReactComponent };